import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { ChecklistLead, LeadFilters, LeadStatus } from '@/types/leads.types';
import { toast } from 'sonner';

export const useLeadsData = (filters: LeadFilters) => {
  const [leads, setLeads] = useState<ChecklistLead[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLeads = async () => {
      setLoading(true);
      
      let query = supabase
        .from('checklist_leads')
        .select('*')
        .order('created_at', { ascending: false });

      // Apply date filters
      if (filters.dateFrom) {
        query = query.gte('created_at', filters.dateFrom.toISOString());
      }
      if (filters.dateTo) {
        // Add 1 day to include the end date
        const endDate = new Date(filters.dateTo);
        endDate.setDate(endDate.getDate() + 1);
        query = query.lt('created_at', endDate.toISOString());
      }

      // Apply practice type filter
      if (filters.practiceType && filters.practiceType !== 'all') {
        query = query.eq('practice_type', filters.practiceType);
      }

      // Apply consultation filter
      if (filters.consultationFilter === 'yes') {
        query = query.eq('wants_consultation', true);
      } else if (filters.consultationFilter === 'no') {
        query = query.eq('wants_consultation', false);
      }

      // Apply status filter
      if (filters.statusFilter && filters.statusFilter !== 'all') {
        query = query.eq('status', filters.statusFilter as LeadStatus);
      }

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching leads:', error);
        toast.error('Fehler beim Laden der Leads');
        setLoading(false);
        return;
      }

      setLeads(data || []);
      setLoading(false);
    };

    fetchLeads();
  }, [filters.dateFrom, filters.dateTo, filters.practiceType, filters.consultationFilter, filters.statusFilter]);

  return { leads, loading };
};
